import constants from 'constants';

const {
  ADD_VIMEO_VIDEO_DATA
} = constants;

const vimeo = (vimeo = {}, action) => {
  switch(action.type) {
    case ADD_VIMEO_VIDEO_DATA:
      return {
        ...vimeo,
        [action.payload.uid]: action.payload.data
      }
    default:
      return vimeo;
  }
}

export { vimeo };



/** WEBPACK FOOTER **
 ** ./src/reducers/vimeo.js
 **/